module.exports = __webpack_public_path__ + "media/react/marketing/pages/gre/plans/assets/concentric_circles-96d2343b5ec38c7912d80f0dacd8c90f.svg";